export enum ProductState {
  NotAvailable,
  Discontinued,
  Supported,
  Available,
}
